import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { dateFormat } from '../utils/dateFormat';

interface TaskRow {
  date: string;
  comments: string;
  hours: string;
}

interface ViewActivityTasksModalProps {
  open: boolean;
  onClose: () => void;
  tasks: TaskRow[];
  activityName?: string;
}

const ViewActivityTasksModal: React.FC<ViewActivityTasksModalProps> = ({ open, onClose, tasks, activityName }) => {
  return (
    <Modal
      open={open}
      onClose={(_event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        onClose();
      }}
      disableEscapeKeyDown
    >
      <Box
        sx={{
          width: 540,
          bgcolor: '#fff',
          borderRadius: 3,
          boxShadow: 24,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          maxHeight: '70vh',
          display: 'flex',
          flexDirection: 'column',
          p: 0,
        }}
      >
        <Box px={3} pt={2.5} pb={1.5} display="flex" alignItems="center" justifyContent="space-between" borderBottom="1px solid #e0e0e0">
          <Typography fontSize={18} fontWeight={700} color="#0B3A6A" sx={{ lineHeight: 1.2 }}>
            Task Details{activityName ? ` - ${activityName}` : ''}
          </Typography>
          <IconButton onClick={onClose} size="small" sx={{ ml: 1 }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <TableContainer component={Paper} sx={{ boxShadow: 'none', mx: 0, my: 0, maxHeight: 340, borderRadius: 0 }}>
          <Table size="small" sx={{ minWidth: 500 }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, width: 110, background: '#f7fafd' }}>Date</TableCell>
                <TableCell sx={{ fontWeight: 600, width: 320, background: '#f7fafd' }}>Comments</TableCell>
                <TableCell sx={{ fontWeight: 600, width: 60, background: '#f7fafd', textAlign: 'center' }}>Hours</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tasks.map((row, idx) => (
                <TableRow key={idx}>
                  <TableCell sx={{ verticalAlign: 'top', fontSize: 14 }}>{dateFormat(row.date)}</TableCell>
                  <TableCell sx={{ verticalAlign: 'top', fontSize: 14, whiteSpace: 'pre-line', wordBreak: 'break-word', maxWidth: 320, minWidth: 120 }}>{row.comments}</TableCell>
                  <TableCell sx={{ verticalAlign: 'top', fontSize: 14, textAlign: 'center' }}>{row.hours}</TableCell>
                </TableRow>
              ))}
              {tasks.length === 0 && (
                <TableRow>
                  <TableCell colSpan={3} align="center" sx={{ color: '#aaa' }}>
                    No tasks found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Modal>
  );
};

export default ViewActivityTasksModal;
